import { Flex } from '@iheartjane/reefer';

import { FormSection } from './FormSection';

export const CategoryTabsSection = () => {
  return (
    <Flex gap={24} flexDirection="column">
      <FormSection
        name="category_tabs.style"
        title="Style"
        subtitle="Visual treatement of each category card"
        options={[
          {
            label: 'Stacked',
            value: 'icon',
            defaultOption: true,
          },
          {
            label: 'Pills',
            value: 'pill',
          },
          {
            label: 'Tiles',
            value: 'tile',
          },
          {
            label: 'Tabs',
            value: 'tab',
          },
          {
            label: 'Image cards',
            value: 'image',
          },
        ]}
      />
      <FormSection
        name="category_tabs.position"
        title="Placement"
        subtitle="Where the category row sits on the page"
        helperText="Only applies if your featured page has a carousel"
        options={[
          {
            label: 'Above carousel',
            value: 'above_carousel',
            defaultOption: true,
          },
          {
            label: 'Below carousel',
            value: 'below_carousel',
          },
        ]}
      />
    </Flex>
  );
};
